import { QuickViewFile } from './QuickViewFile';
import {
  FileTrackerDetailProps,
  FileTrackerListFileProps,
  FileTrackerStageEnum,
} from '../file-tracker-types';
import { useState, useEffect } from 'react';
import {
  Tooltip,
  Grid,
  GridItem,
  Icon,
  Text,
  IconProps,
} from '@chakra-ui/react';
import { AiOutlineRightCircle } from 'react-icons/ai/index.js';
interface FileProps {
  record: FileTrackerListFileProps;
  getFileStatus?: (
    val: FileTrackerListFileProps,
  ) => Promise<FileTrackerDetailProps | undefined>;
  isQuickViewRequired: boolean;
}

const CircleIcon = (props: IconProps) => (
  <Icon viewBox='0 0 200 200' {...props}>
    <path
      fill='currentColor'
      d='M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0'
    />
  </Icon>
);

export const FileStatus = ({
  record,
  getFileStatus,
  isQuickViewRequired,
}: FileProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileDetails, setFileDetails] = useState<FileTrackerDetailProps>();

  const getStyles = (stage: string) => {
    switch (stage) {
      case FileTrackerStageEnum.FILE_RECEIVED:
      case FileTrackerStageEnum.FILE_IS_RECEIVED:
        return { bg: '#F1FCF5', color: '#32C263' };
      case FileTrackerStageEnum.MALWARE_SCAN_COMPLETED:
        return { bg: '#F2FAE8', color: '#83C232' };
      case FileTrackerStageEnum.MALWARE_SCAN_INPROGRESS:
      case FileTrackerStageEnum.FILE_SAMPLING_IN_PROGRESS:
        return { bg: '#FFF6E4', color: '#FBAD18' };
      case FileTrackerStageEnum.FILE_IS_AVAILABLE:
        return { bg: '#E9F1FF', color: '#5AB2F1' };
      case FileTrackerStageEnum.FILE_SAMPLING_FAILED:
      case FileTrackerStageEnum.MALWARE_SCAN_FAILED:
        return { bg: '#fae2e5', color: '#e4002b' };
      default:
        return { bg: '#F1FCF5', color: '#32C263' };
    }
  };

  useEffect(() => {
    setIsLoading(false);
  }, [fileDetails]);

  return (
    <Grid templateColumns={'repeat(6, 1fr)'}>
      <GridItem sx={{ alignItems: 'center' }} colSpan={5}>
        <Tooltip label={record.stage || ''} placement='top'>
          <Text
            sx={{
              padding: '4px 10px',
              borderRadius: 4,
              width: 'fit-content',
              background: getStyles(record.stage).bg,
            }}
          >
            <CircleIcon
              boxSize={2}
              mr={1}
              verticalAlign='unset'
              color={getStyles(record.stage).color}
            />
            {record.stage}
          </Text>
        </Tooltip>
      </GridItem>
      {isQuickViewRequired && (
        <GridItem colStart={6} colEnd={7}>
          <Icon
            as={AiOutlineRightCircle}
            h='7'
            w='7'
            mb='-3'
            color={'gray.500'}
            cursor={'pointer'}
            onClick={async () => {
              if (getFileStatus) {
                setIsOpen(true);
                setIsLoading(true);
                const fileData = await getFileStatus(record);
                fileData && setFileDetails(fileData);
              }
            }}
          />
          <QuickViewFile
            isOpen={isOpen}
            setonOpen={setIsOpen}
            fileDetails={fileDetails}
            isLoading={isLoading}
            record={record}
          />
        </GridItem>
      )}
    </Grid>
  );
};
